<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6">{{ dialog_title }}</span>
                    <div class="text-caption">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row>
                        <v-col cols="4" class="h-100 d-flex flex-column" style="min-width: 300px; min-height: 500px; height: 100%;">
                            <v-timeline direction="vertical" truncate-line="both" side="end" class="flex-grow-1">
                                <v-timeline-item dot-color="orange" size="small">
                                    <template v-slot:opposite>
                                        <div class="text-button font-weight-bold text-uppercase">{{ formatDate(complianceData?.date_submitted) }}</div>
                                    </template>
                                    <div>
                                        <div class="text-body-2 font-weight-bold">Submitted By</div>
                                        <p class="text-subtitle-2">{{ complianceData?.file.submittedBy.fname }} {{ complianceData?.file.submittedBy.lname }}</p>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item dot-color="yellow" size="small">
                                    <template v-slot:opposite>
                                        <div class="text-button font-weight-bold text-uppercase">For Review</div>
                                    </template>
                                </v-timeline-item>
                                <v-timeline-item v-if="complianceData.file.review_status != null" :dot-color="complianceData.file.review_status == 'reviewed' ? 'blue' : 'red'" size="small">
                                    <template v-slot:opposite>
                                        <p class="text-button font-weight-bold text-uppercase">{{ complianceData.file.review_status }}</p>
                                    </template>
                                    <div>
                                        <div class="text-body-2 font-weight-bold">Reviewer</div>
                                        <p class="text-body-2">{{ complianceData.file.reviewer.fname }} {{ complianceData.file.reviewer.lname }}</p>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item v-if="complianceData.file.review_status === 'reviewed'" dot-color="yellow" size="small">
                                    <template v-slot:opposite>
                                        <div class="text-button font-weight-bold text-uppercase">For Approval</div>
                                    </template>
                                </v-timeline-item>
                                <v-timeline-item v-if="complianceData.file.approval_status != null" :dot-color="complianceData.file.approval_status == 'approved' ? 'green' : 'red'" size="small">
                                    <template v-slot:opposite>
                                        <div class="text-button font-weight-bold text-uppercase">Approved</div>
                                    </template>
                                    <div>
                                        <div class="text-body-2 font-weight-bold">Approver</div>
                                        <p class="text-body-2">{{ complianceData.file.approver.fname }} {{ complianceData.file.approver.lname }}</p>
                                    </div>
                                </v-timeline-item>
                            </v-timeline>
                        </v-col>

                        <!-- Right-Side Content -->
                        <v-col cols="12" md="8" class="d-flex flex-column" style="flex-grow: 1; height: 100%;">
                            <v-card elevation="4">
                                <v-card-title>Course Load Details</v-card-title>
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="6">
                                            <div class="font-weight-bold">Course Code:</div>
                                            <div>{{ complianceData.facultyLoad.code }}</div>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <div class="font-weight-bold">Course Title:</div>
                                            <div>{{ complianceData.facultyLoad.title }}</div>
                                        </v-col>
                                        <v-col v-if="!complianceData.compliance.is_sorted_course" cols="12" md="6">
                                            <div class="font-weight-bold">Program and Section:</div>
                                            <div>{{ complianceData.facultyLoad.section_code }}</div>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <div class="font-weight-bold">Course Type:</div>
                                            <div>{{ complianceData.facultyLoad.course_type }}</div>
                                        </v-col>
                                        <v-col v-if="complianceData.compliance.is_term_separated" cols="12" md="6">
                                            <div class="font-weight-bold">Term</div>
                                            <div>{{ complianceData.term.name }}</div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                            <v-card elevation="4" class="mt-2">
                                <v-card-title>Faculty Tagged Details</v-card-title>
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <div class="d-flex flex-wrap mt-2 ga-3">
                                    <v-card
                                        v-for="data in complianceData.sameFileUsers"
                                        :key="data.id"
                                        elevation="3"
                                        rounded="xl"
                                        class="pa-3 d-flex align-center"
                                        style="width: 300px;"
                                    >
                                        <v-avatar class="me-3">
                                        <v-img
                                            v-if="!data.picUrl"
                                            src="../../assets/profile-pic.png"
                                        ></v-img>
                                        <v-img
                                            v-else
                                            :src="data.picUrl"
                                            @error="onImageError"
                                        ></v-img>
                                        </v-avatar>
                                        <div>
                                        <div class="font-weight-bold">
                                            {{ data.fname }} {{ data.lname }}
                                        </div>
                                        <div
                                            v-for="f in data.facultyLoad"
                                            :key="f.id"
                                            class="text-caption"
                                        >
                                            {{ f.section_code }}
                                        </div>
                                        </div>
                                    </v-card>
                                    </div>
                                </v-card-text>
                            </v-card>
                            <v-card elevation="4" class="mt-2">
                                <v-card-title>Upload Details</v-card-title>
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row v-if="complianceData.file.filenames.length > 0" class="mt-2">
                                        <v-col v-for="file in complianceData.file.filenames" :key="file" cols="12" md="6">
                                            <v-card
                                                @click="showViewFileDialog(file)"
                                                elevation="3"
                                                append-icon="mdi-open-in-new"
                                                class="mx-auto"
                                                :title="file"
                                                subtitle="application/pdf"
                                            ></v-card>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col cols="12">
                                            <div class="font-weight-bold">Notes:</div>
                                            <div>{{ complianceData.file.note ? complianceData.file.note : '---' }}</div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col v-if="complianceData.compliance.is_checklist == true" cols="12" md="6">
                            <v-card elevation="4">
                                <v-card-title>
                                    <v-row align="center" no-gutters>
                                        <span>Checklist</span>
                                        <v-spacer></v-spacer>
                                        <div v-if="complianceData.file.checklists" class="d-flex ga-1">
                                            <v-btn
                                                @click="printChecklist(complianceData)"
                                                :disabled="loading"
                                                text="Print Checklist"
                                                variant="elevated"
                                                elevation="3"
                                                color="orange-darken-1"
                                                size="small"
                                            ></v-btn>
                                            <v-btn
                                                @click="showViewChecklist(complianceData)"
                                                :disabled="loading"
                                                text="View Checklist"
                                                variant="elevated"
                                                elevation="3"
                                                color="darkGreen"
                                                size="small"
                                            ></v-btn>
                                        </div>
                                    </v-row>
                                </v-card-title>

                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row dense class="mt-2">
                                        <v-col v-if="!filteredChecklists.length" cols="12">
                                            <v-card elevation="3">
                                                <v-card-text v-if="!complianceData.file.checklists">No Checklist Items</v-card-text>
                                                <v-card-text v-else class="font-weight-bold"><v-icon color="green">mdi-check</v-icon> All Checklist for this compliance is completed</v-card-text>
                                            </v-card>
                                        </v-col>

                                        <v-col v-else cols="12">
                                            <span class="font-weight-bold">Indicators that is not found in this compliance</span>
                                            <v-card
                                                elevation="3"
                                                v-for="(checklist, index) in filteredChecklists"
                                                :key="index"
                                                class="mt-4"
                                            >
                                                <v-card-title>
                                                    <v-icon color="red" size="small">mdi-close-circle</v-icon>
                                                    <span class="text-subtitle-1 ml-2">{{ checklist.indicator }}</span>
                                                </v-card-title>

                                                <v-card-text>
                                                    <template v-if="checklist.subIndicators">
                                                        <v-list dense>
                                                            <v-list-item
                                                                v-for="(sub, subIndex) in checklist.subIndicators.filter(sub => sub.answer === 'no')"
                                                                :key="subIndex"
                                                            >
                                                                <div class="d-flex align-center ga-2">
                                                                    <v-icon color="red">mdi-alert-circle</v-icon>
                                                                    <v-list-item-title>{{ sub.name }}</v-list-item-title>   
                                                                </div>
                                                                <v-chip color="gray" text-color="white" class="mt-3">
                                                                    Remarks: {{ sub.remarks }}
                                                                </v-chip>
                                                            </v-list-item>
                                                        </v-list>
                                                    </template>
                                                    <v-chip v-if="!checklist.subIndicators.some(sub => sub.answer === 'no')" color="gray" text-color="white">
                                                        Remarks: {{ checklist.remarks }}
                                                    </v-chip>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" :md="complianceData.compliance.is_checklist == true? '6' : '12'">
                            <v-card elevation="4">
                                <v-card-title>Revision Logs</v-card-title>
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row>
                                        <v-col class="mt-3" v-if="complianceData.file.remarks.length == 0" cols="12">
                                            <v-card  elevation="3">
                                                <v-card-text>
                                                    No Revisions Yet
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col v-else cols="12">
                                            <v-timeline>
                                                <v-timeline-item
                                                    v-for="(remark, index) in complianceData.file.remarks" :key="remark"
                                                    size="x-small"
                                                    :dot-color="getColorByStatus(remark.remarks_type)"
                                                >
                                                    <v-alert
                                                        variant="tonal"
                                                        :border="index % 2 === 0 ? 'start' : 'end'"
                                                        :color="getColorByStatus(remark.remarks_type)"
                                                    >
                                                        <div style="white-space: pre-line;">
                                                            {{ remark.details }}
                                                        </div>
                                                        
                                                        <div v-if="remark.remarks_type == 'returned'" density="compact" class="my-2">
                                                            <div class="font-weight-bold">Remarks: </div>
                                                            <div class="font-italic">"{{ remark.remarks }}"</div>
                                                        </div>
                                                        <div class="text-caption mt-3">
                                                            {{ remark.createdBy.fname }} {{ remark.createdBy.lname }} - {{ formatDate(remark.datecreated) }}
                                                        </div>
                                                    </v-alert>
                                                </v-timeline-item>
                                            </v-timeline>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <!-- <v-card-actions v-if="complianceData.file.approval_status == null" class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                
            </v-card-actions> -->
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn :disabled="loading" text="Close" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn :disabled="loading" text="Return" variant="elevated" elevation="1" color="red" @click="showRemarksDialog(this.complianceData)"></v-btn>
                <v-btn v-if="complianceData.file.approval_status == null" :loading="loading" text="Approved" variant="elevated" elevation="1" color="darkGreen" @click="confirmApprove = true"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmApprove" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to confirm approve this compliance?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, some details may not be updated. Please review the information carefully before proceeding.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmApprove = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="approveCompliance()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <ApprovalRemarksDialog ref="ApprovalRemarksDialog" @refresh="loadCompliance()"/>
    <ChecklistDialog ref="ChecklistDialog"/>
    <ViewFileDialog ref="ViewFileDialog"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import ChecklistDialog from './Sub-Dialogs/ChecklistDialog.vue';
import ApprovalRemarksDialog from './Sub-Dialogs/ApprovalRemarksDialog.vue';
import { useSnackbar } from '@/composables/useSnackbar';
import ViewFileDialog from './Sub-Dialogs/ViewFileDialog.vue';


export default defineComponent({
     emits: ["refresh"],
     components: {
        ApprovalRemarksDialog,
        ChecklistDialog,
        ViewFileDialog
     },
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            complianceData: [],
            checklistData: [],

            file_id: null,
            created_by: null,

            errored: false,
            confirmApprove: false
        }
     },
     computed: {
        filteredChecklists() {
            if (!this.complianceData.file.checklists) return [];

            return this.complianceData.file.checklists
                .map(item => {
                    let hasNoAnswer = String(item.answer).toLowerCase() === "no";
                    let subNoIndicators = item.subIndicators?.filter(sub => String(sub.answer).toLowerCase() === "no") || [];

                    if (hasNoAnswer && subNoIndicators.length) {
                        return { ...item, sub_indicators: subNoIndicators };
                    } else if (hasNoAnswer) {
                        return item;
                    } else if (subNoIndicators.length) {
                        return { ...item, sub_indicators: subNoIndicators };
                    }

                    return null;
                })
                .filter(Boolean);
        },
        currentImage() {
        return this.errored || !this.$store.state.user.picUrl
            ? require('@/assets/profile-pic.png')
            : this.$store.state.user.picUrl;
        }
     },
     methods: {
        initView(data){
            this.dialog = true
            this.dialog_title = 'Approve Submitted Compliance'
            this.dialog_sub_title = data.compliance.compliance_name
            this.action = 'add'

            this.complianceData = data
            this.checklistData = data.file.checklists

            this.file_id = data.file_id
            this.created_by = this.$store.state.user.id

            this.getUsersWithFileId(this.complianceData.file_id)
        },
        // async streamFile(file) {
        //     this.loading = true;

        //     try {
        //         const fileURL = `${process.env.VUE_APP_SERVER_URL}/compliance-upload/stream-file/${file}`;
                
        //         // Open the file directly in a new tab
        //         window.open(fileURL, '_blank');

        //         this.loading = false;

        //     } catch (error) {
        //         console.error('Error streaming the file:', error);
        //         this.loading = false;
        //     }
        // },
        getColorByStatus(status){
            if(status == 'returned'){
                return 'red'
            }
            else if(status == 'reviewed'){
                return 'blue'
            }
            else if(status == 'approved'){
                return 'green'
            }
            else if (status == 'resubmission'){
                return 'orange-accent-4'
            }
            else{
                return 'gray'
            }
        },
        showRemarksDialog(data){
            this.$refs.ApprovalRemarksDialog.initReturn(data)
        },
        showViewChecklist(data){
            this.$refs.ChecklistDialog.initView(data)
        },
        showViewFileDialog(data){
            this.$refs.ViewFileDialog.viewFile(data)
        },
        loadCompliance(){
            this.$emit('refresh')
            this.closeDialog()
        },
        async getUsersWithFileId(file_id){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details/findAllFacultiesWithSameFileId/' + file_id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.complianceData.sameFileUsers = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        approveCompliance(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            let formData = {
                file_id: this.file_id,
                compliance_data: this.complianceData,
                created_by: this.created_by
            }

            const token = localStorage.getItem('aums-token')

            axios.post(process.env.VUE_APP_SERVER_URL + '/compliance-upload/approveForApprovalCompliances', formData,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    this.loading = false
                    this.$emit('refresh')
                    showSnackbar('Compliance successfully approved!')
                    this.$refs.form.reset()
                    this.confirmApprove = false
                    this.dialog = false
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            })
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        },
        async printChecklist(complianceFile) {
            const checklistData = complianceFile.file.checklists;
            const reviewer = complianceFile.file.reviewer || null;
            const approver = complianceFile.file.approver || null;

            let body = [
                [
                { text: "INDICATORS", bold: true },
                { text: "Y", bold: true, alignment: "center" },
                { text: "N", bold: true, alignment: "center" },
                { text: "N/A", bold: true, alignment: "center" },
                { text: "R", bold: true, alignment: "center" }
                ]
            ];

            checklistData.forEach(item => {
                if (item.hasSubIndicators && item.subIndicators.length > 0) {
                body.push([
                    { text: item.indicator, bold: true, colSpan: 5, margin: [0, 5, 0, 2] },
                    {}, {}, {}, {}
                ]);

                item.subIndicators.forEach(sub => {
                    body.push([
                    { text: `   • ${sub.name}`, margin: [10, 0, 0, 0] },
                    { text: sub.answer === "yes" ? "•" : "", alignment: "center" },
                    { text: sub.answer === "no" ? "X" : "", alignment: "center" },
                    { text: sub.answer === "na" ? "-" : "", alignment: "center" },
                    { text: sub.remarks || "", italics: true }
                    ]);
                });
                } else {
                body.push([
                    { text: item.indicator },
                    { text: item.answer === "yes" ? "•" : "", alignment: "center" },
                    { text: item.answer === "no" ? "X" : "", alignment: "center" },
                    { text: item.answer === "na" ? "-" : "", alignment: "center" },
                    { text: item.remarks || "", italics: true }
                ]);
                }
            });

            // build reviewer column
            const reviewerColumn = {
                stack: [
                { text: "Reviewed by:", margin: [0, 20, 0, 5] },
                { text: "____________________" },
                reviewer
                    ? { text: `${reviewer.fname} ${reviewer.lname}${reviewer.post_nominal ? ", " + reviewer.post_nominal : ""}`, bold: true }
                    : { text: "", margin: [0, 5, 0, 0] },
                reviewer
                    ? { text: reviewer.designation, italics: true }
                    : { text: "" }
                ]
            };

            // build approver column only if present
            const approverColumn = approver
                ? {
                    stack: [
                    { text: "Approved by:", margin: [0, 20, 0, 5] },
                    { text: "____________________" },
                    { text: `${approver.fname} ${approver.lname}${approver.post_nominal ? ", " + approver.post_nominal : ""}`, bold: true },
                    { text: approver.designation, italics: true }
                    ]
                }
                : null;

            let docDefinition = {
                defaultStyle: {
                font: "ArialNarrow",
                fontSize: 9
                },
                pageSize: { width: 612, height: 936 }, // 8.5in x 13in (long bond)
                pageOrientation: "portrait",
                pageMargins: [40, 40, 40, 40],
                content: [
                {
                    text: "SYLLABUS REVIEW CHECKLIST",
                    style: "title",
                    margin: [0, 0, 0, 10]
                },
                {
                    // Program / Institute / Course Info
                    table: {
                    widths: ["*", "*"],
                    body: [
                        [
                        { text: `Program: ${complianceFile.file.program?.abbrev || ""}` },
                        ],
                        [
                        { text: `Course Code: ${complianceFile.facultyLoad?.code || ""}` },
                        ],
                        [
                        { text: `Course Title: ${complianceFile.facultyLoad?.title || ""}`, colSpan: 2 },
                        {}
                        ]
                    ]
                    },
                    layout: "noBorders",
                    margin: [0, 0, 0, 15]
                },
                {
                    table: {
                    headerRows: 1,
                    widths: ["*", 30, 30, 30, 100],
                    body
                    },
                    layout: {
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0.5,
                    hLineColor: () => "#aaa",
                    vLineColor: () => "#aaa"
                    }
                },
                {
                    columns: approver ? [reviewerColumn, approverColumn] : [reviewerColumn]
                }
                ],
                styles: {
                title: { fontSize: 12, bold: true, alignment: "center" }
                }
            };
            pdfMake.createPdf(docDefinition).open();
        }
     }
})
</script>

<style scoped>

</style>